import React from 'react'

export const SliderIconLeft = () => {
  return (
   <svg xmlns="http://www.w3.org/2000/svg" width="62" height="62" viewBox="0 0 62 62" fill="none">
<rect x="0.100579" y="0.699917" width="43" height="43" rx="21.5" transform="matrix(-0.599338 0.800496 0.800496 0.599338 26.3787 0.199917)" stroke="white"/>
<path d="M41.5031 30.9339L21.509 30.4487M21.509 30.4487L30.7247 21.6697M21.509 30.4487L30.288 39.6644" stroke="white" stroke-width="2"/>
</svg>
  )
}
